import { type ReactNode } from 'react';

import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

export const ThemeChip = ({ children }: { children: ReactNode }) => (
	<span css={themeChipStyles}>{children}</span>
);

const themeChipStyles = css({
	display: 'inline-flex',
	alignItems: 'center',
	height: '20px',
	paddingInline: token('space.050'),
	borderRadius: token('radius.small'),
	backgroundColor: token('color.background.neutral'),
	color: token('color.text'),
	font: token('font.body.small'),
	whiteSpace: 'nowrap',
});
